module.exports = __webpack_public_path__ + "static/media/cart_dark.d698b75e.svg";